import { render, staticRenderFns } from "./personal-policy-detail-info.vue?vue&type=template&id=759192a2&scoped=true&"
import script from "./personal-policy-detail-info.vue?vue&type=script&lang=js&"
export * from "./personal-policy-detail-info.vue?vue&type=script&lang=js&"
import style0 from "./personal-policy-detail-info.vue?vue&type=style&index=0&id=759192a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759192a2",
  null
  
)

export default component.exports